
export const typeData = [
    { name: "AVOB Box", id: 3},
    { name: "AVOB Box lite", id: 4},
];

export const serverTypeBoxCreationData = [
    { name: "Serveur LoRaWAN AVOB", id: "avoblorawanserver"},
];
export const serverTypeBoxModificationData = [
    { name: "Serveur LoRaWAN AVOB", id: "avoblorawanserver"},
    { name: "Serveur AVOB", id: "avobeosserver"},
];
export const serverTypeLorawanGateway = [
    { name: "Serveur LoRaWAN AVOB", id: "avoblorawanserver"},
    { name: "AVOB Energy Box", id: "avobenergybox"},
];